export default __webpack_public_path__ + "static/media/media2.3d7878ec.jpg";